export const NotFound = () => {
    return (
        <>
        <h1>404 Error Page</h1>
        <p>Please go back and try again.</p>
        </>
        
    );
}